import Swiper from "swiper";
import { Pagination, EffectCreative, Autoplay } from "swiper/modules";

// Required CSS for the Creative effect
import "swiper/css";
import "swiper/css/effect-creative";

export const initServicesDeck = (): void => {
  const sliders = document.querySelectorAll<HTMLElement>(
    ".services-deck__swiper",
  );

  if (sliders.length === 0) return;

  sliders.forEach((sliderElement) => {
    if (sliderElement.dataset.initialized === "true") return;
    sliderElement.dataset.initialized = "true";

    const paginationEl = sliderElement.querySelector<HTMLElement>(
      ".services-deck__pagination",
    );

    new Swiper(sliderElement, {
      modules: [Pagination, EffectCreative, Autoplay],
      effect: "creative",
      grabCursor: true,
      centeredSlides: true,
      slidesPerView: "auto", // Automatically maps to the explicitly set CSS width
      loop: true,
      autoplay: {
        delay: 3500,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      creativeEffect: {
        limitProgress: 2, // How many slides to render on the sides

        // Settings for the Left Card
        prev: {
          translate: ["-110%", 0, -200], // Translate X (-110%), Y (0), Z (-200px backward)
          rotate: [0, 0, -8], // Lean left
          opacity: 0.8,
        },

        // Settings for the Right Card
        next: {
          translate: ["110%", 0, -200], // Translate X (110%), Y (0), Z (-200px backward)
          rotate: [0, 0, 8], // Lean right
          opacity: 0.8,
        },
      },
      pagination: {
        el: paginationEl,
        clickable: true,
      },
    });
  });

  console.log("[ServicesDeck] Swiper initialized with 3D Creative Effect.");
};
